<template lang="pug">
  .retain-dialog(
    v-if="showDialog"
    @touchmove.prevent
  )
    .content-wrapper
      .head-title 你有骑行卡未开通，确认放弃？
      .sub-title 也可稍后前往我的-我的资产-卡自助开通
      .card-info(v-if="isTwCard")
        .card-content
          .use-tip(v-if="cardInfo.isAppOnly")
          .card-title {{ cardInfo.cardMainTitle }}
          .card-desc
            highlight-text(
              :text="cardInfo.cardSubTitle"
              :normalStyle="normalStyle"
              :highlightStyle="highlightStyle"
            )
            .card-use-attr {{ cardInfo.useTip }}
          .card-price(v-if="cardInfo.cardPrice")
            span 价值
            span.num {{ cardInfo.cardPrice }}
            span 元
      img.card(:src="retainPopupImg" v-else)
      .btn-container
        .left-btn(@click="closeWebView")
          .left-text 残忍离开
        .right-btn(@click="goCardPage")
          .right-text 前往开通
    img.close-icon(src="https://assets.51downapp.cn/file-1754910364493-666330434.png" @click="goCardPage")
</template>

<script>
import highlightText from '@/components/highlight-text.vue';

export default {
  name: 'RetainDialog',
  components: {
    highlightText,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    retainPopupImg: {
      type: String,
      default: '',
    },
    handleBack: {
      type: Function,
      default: () => {},
    },
    cardInfo: {
      type: Object,
      default: () => ({
        // mainTitle: '单车30天卡 单单仅需1分钱',
        // cardMainTitle: '哈啰单车骑行卡  单单仅需0.01元',
        // cardSubTitle: '{30}天{12}次',
        // cardPrice: 35,
        // useTip: '全国通用',
        // isAppOnly: true,
        // useDesc: '{限哈啰APP} 扫码开锁骑行',
        // useDesc2: '{前120分钟} {仅需0.01元} 超出部分按照单次计费为准',
      }),
    },
    isTwCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      normalStyle: {
        color: '#fff',
        fontSize: '0.126rem',
        fontWeight: 500,
        fontFamily: 'DINAlternate',
      },
      highlightStyle: {
        color: '#fff',
        fontSize: '0.25rem',
        fontWeight: 500,
        fontFamily: 'DINAlternate',
        marginRight: '0.04rem',
      },
    };
  },
  mounted() {
  },
  methods: {
    goCardPage() {
      this.$emit('close');
    },
    closeWebView() {
      this.handleBack();
    },
  },
};
</script>

<style lang="less" scoped>
.retain-dialog {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  z-index: 99;

  .content-wrapper {
    position: relative;
    width: 2.97rem;
    height: 3.39rem;
    margin-top: 2.3rem;
    background: url('https://assets.51downapp.cn/file-1754910551269-310646686.png') center/contain no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;

    .head-title {
      margin-top: 0.92rem;
      color: #000;
      font-weight: 500;
      font-size: 0.17rem;
      text-align: center;
    }

    .sub-title {
      margin-top: 0.07rem;
      color: #5a6066;
      font-weight: 400;
      font-size: 0.12rem;
      text-align: center;
    }

    .card {
      margin-top: 0.2rem;
      width: 2.47rem;
      height: 0.82rem;
    }

    .card-info {
      width: 2.6rem;
      height: 0.84rem;
      box-sizing: content-box;
      margin: 0.12rem auto 0;
      padding: 0 0.09rem 0.19rem;
      background: url('https://m.hellobike.com/2210e352b2.png') no-repeat center/100% 100%;
      position: relative;

      .card-content {
        box-sizing: border-box;
        padding: 0.14rem 0.17rem 0;
        position: relative;
        height: 100%;

        .use-tip {
          position: absolute;
          top: 0;
          right: 0;
          width: 0.64rem;
          height: 0.16rem;
          transform: translateX(0.02rem);
          background: url('https://m.hellobike.com/c07e0cdb_Group_1707483907.png') no-repeat center/100% 100%;
        }

        .card-title {
          font-size: 0.14rem;
          color: #fff;
          font-weight: 600;
          padding-top: 0.04rem;
        }

        .card-desc {
          margin-top: 0.02rem;
          display: flex;
          align-items: baseline;

          .card-use-attr {
            font-size: 0.095rem;
            color: rgba(255, 255, 255, 0.7);
            font-weight: 400;
            margin-left: 0.05rem;
          }
        }

        .card-price {
          font-size: 0.12rem;
          color: rgba(255, 255, 255, 0.5);
          font-weight: 600;
          margin-top: 0.06rem;
          display: flex;
          align-items: baseline;
          position: absolute;
          right: 0.13rem;
          bottom: 0.1rem;

          .num {
            font-size: 0.18rem;
            font-weight: 700;
            font-family: 'DINAlternate', sans-serif;
          }
        }
      }
    }

    .btn-container {
      position: absolute;
      bottom: 0.14rem;
      left: 0.09rem;
      right: 0.1rem;
      height: 0.96rem;
      background: url("https://assets.51downapp.cn/file-1754965741623-351235352.png") center/contain no-repeat;
      // background: linear-gradient(180deg, rgba(197, 228, 255, 0.9) 0%, #fff 100%);
      // border-bottom-left-radius: 0.30rem;
      // border-bottom-right-radius: 0.50rem;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.19rem;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(180deg, rgba(197, 228, 255, 0.9) 0%, #fff 100%);
      }

      .left-btn,
      .right-btn {
        width: 1.08rem;
        height: 0.44rem;
        border-radius: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 0.16rem;
        font-weight: 400;
      }

      .left-btn {
        background-color: #fff;
        border: 1px solid #08f;

        .left-text {
          color: #08f;
        }
      }

      .right-btn {
        background-color: #08f;

        .right-text {
          color: #fff;
          font-weight: 500;
        }
      }
    }
  }

  .close-icon {
    width: 0.32rem;
    height: 0.32rem;
    margin-top: 0.54rem;
  }
}
</style>
